import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { EmbeddingContainer } from '../features/embedding/components/EmbeddingContainer';
import { config } from '../config/env';
import { useAuthorization } from '@/features/auth/hooks';
import { useShellI18n } from '@/features/language/useI18n';

export const AppDetailPage: React.FC = () => {
  const { appId } = useParams<{ appId: string }>();
  const navigate = useNavigate();
  const { filterServices } = useAuthorization();
  const embeddedServices = filterServices(config().EMBEDDED_SERVICES || []);
  const service = embeddedServices.find((entry) => entry.id === appId);
  const { t } = useShellI18n();

  useEffect(() => {
    if (!service) {
      navigate('/community', { replace: true });
    }
  }, [service, navigate]);

  if (!service) {
    return null;
  }

  return (
    <section className="embed-screen">
      <div className="embed-head">
        <div className="embed-head-left">
          <button
            type="button"
            className="btn ghost sm"
            onClick={() => navigate('/community')}
            aria-label={t('Back to community')}
          >
            {t('Back')}
          </button>
          <div>
            <h1 className="panel-title">{service.name}</h1>
            <p className="meta">{service.url}</p>
          </div>
        </div>
        <span className="pill">{service.type}</span>
      </div>

      <div className="embed-stage">
        <EmbeddingContainer service={service} className="embed-frame-wrap" />
      </div>
    </section>
  );
};
